var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.895 20.814h-.281v-3.689h-.01c-.102-4.12-3.466-7.43-7.61-7.43-4.146 0-7.51 3.31-7.612 7.43h-.01v3.69h-.28c-.867 0-1.57.702-1.57 1.57v1.128h18.942v-1.128c0-.868-.703-1.57-1.57-1.57m-6.841-9.323c2.417 0 4.362 1.88 4.451 4.29.002.024.004.047.004.072 0 .325-.262.59-.588.59h-.005c-.32 0-.583-.256-.59-.576-.044-1.79-1.482-3.195-3.272-3.195-.327 0-.591-.264-.591-.59 0-.326.264-.59.59-.59",
    transform: "translate(.616 .898)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.993 5.449c-.408 0-.738-.33-.738-.738V.738c0-.408.33-.738.738-.738s.738.33.738.738v3.973c0 .407-.33.738-.738.738M8.301 8.107c-.288.288-.756.288-1.044 0l-2.809-2.81c-.288-.287-.288-.755 0-1.043.288-.288.756-.288 1.044 0l2.81 2.809c.287.288.287.756 0 1.044M5.449 14.718c0 .408-.33.738-.738.738H.738c-.408 0-.738-.33-.738-.738s.33-.738.738-.738h3.973c.407 0 .738.33.738.738M21.769 8.232c-.288-.288-.288-.755 0-1.044l2.809-2.808c.289-.288.756-.288 1.044 0 .288.288.288.756 0 1.044l-2.809 2.808c-.288.29-.755.29-1.044 0M24.592 14.993c0-.408.33-.738.738-.738h3.972c.408 0 .738.33.738.738s-.33.738-.738.738H25.33c-.408 0-.738-.33-.738-.738",
    transform: "translate(.616 .898)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmWhite);
export default __webpack_public_path__ + "static/media/alarmWhite.f7c61a98eb69eab649dbd24bf7643ec1.svg";
export { ForwardRef as ReactComponent };